import { render } from "./Usuarios.vue?vue&type=template&id=1864f6a1"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"
script.render = render

export default script